import { connect } from "react-redux";
import { FuncionarioViewProps, mapDispatchToFuncionarioProps, mapStateToFuncionarioProps } from "../funcionario.controll";
import { Funcionario } from "../funcionario.model";
import { Select as ViewList } from "../../../components/select";
import { Box, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import { FuncionarioCadastro } from "./funcionario.cad";

const columns: GridColDef[] = [
    { field: 'nome', headerName: 'nome', flex: 3 },
    { field: 'sobrenome', headerName: 'Sobrenome', flex: 3 },
    { field: 'apelido', headerName: 'Apelido', flex: 3 },
    { field: 'whatsapp', headerName: 'WhatsApp', flex: 2 },
    { field: 'n_doc', headerName: 'Documento', flex: 2 },
    { field: 'ativo', headerName: 'Ativo', flex: 2, renderCell:(prm)=>prm.value?"Sim":"Não" },
]

function FuncionarioList(props: FuncionarioViewProps) {
    const { funcionarioActions,funcionarioState } = props
    const { error, loading, msg, row, rows, showAlert, showDialogExluir, status,showCadModal,changeList } = funcionarioState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue,setShowCadModal } = funcionarioActions
    console.log("FuncionarioList props ",props)

    useEffect(()=>{
        read()
    },[])

    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    const handleAlterar = (row: any) => {
        console.log("chamou handleAlterar")
        set(row);
        setShowCadModal(true)
    }

    const handleCloseCadastro = () => {
        console.log("chamou handleCloseCadastro")
        setShowCadModal(false)
    }

    function Cadastro() {
        return FuncionarioCadastro({
            ...props,
            handleCloseView: handleCloseCadastro
        }).renderModal({
            handleClose: handleCloseCadastro,
            show: showCadModal,
            heigth: "auto",
        })
    }

    const List = ()=>{
        return (
            <ViewList
                displayWidth={window.innerWidth}
                title={"Funcionarios Cadastrados"}
                row={row}
                showAlert={showAlert}
                closeAlert={() => setShowAlert(false)}
                msg={msg}
                status={status}
                elevation={1}
                getRowId={(row) => row._id}
                handleOnChange={handleAlterar}
                actionsOnkeyEnter={handleAlterar}
                showSearchContainer={true}
                fontSize={20}
                setTextSearch={() => { }}
                textSearch={""}
                fieldSearch={"nome"}
                columns={columns}
                rows={rows}
                loading={loading}
                setRow={handleAlterar}
                changeList={changeList}
                buttonNew={{
                    show: true,
                    onClick: handleNovo
                }}
                buttonRefresh={{
                    show: true,
                    onClick:()=> read()
                }}
                ListItemTextPrimary={(row: Funcionario) => <Typography component={"span"}>{row.nome} {row.sobrenome}</Typography>}
                ListItemTextSecondary={(row: Funcionario) =>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography component={"span"}>{row.apelido} {row.whatsapp}</Typography>
                    </Box>
                }
            />
        )
    }

    return (
        <div className="modulo">
            <Cadastro />
            <List />
        </div>
    )

}

export default connect(mapStateToFuncionarioProps,mapDispatchToFuncionarioProps)(FuncionarioList);
